<p-card>
  <p-table #dt
    [value]="brands"
    [lazy]="true"
    [paginator]="true"
    [totalRecords]="resultsLength"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} sur {totalRecords}"
    [rows]="pageSize"
    [rowsPerPageOptions]="[10, 20, 50]"
    sortField="name"
    [sortOrder]="1"
    [(selection)]="selectedBrands"
    [columns]="selectedColumns"
    [loading]="isLoadingResults"
    [scrollable]="true" 
    scrollHeight="715px"
    (onLazyLoad)="onLazyLoad($event)"
  >
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track $index) {
          <th [pSortableColumn]="col.field">{{ col.header }} <p-sortIcon [field]="col.field" /></th>
        }
      </tr>
      <tr>
        @for (col of columns; track $index) {
          <th>
            <p-columnFilter
              type="text"
              [field]="col.field"
              placeholder="Filtrer par {{col.header}}"
              ariaLabel="Filter {{col.header}}"
              [showMenu]="false"
            ></p-columnFilter>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template #body let-brand let-columns="columns">
      <tr>
        @for (col of columns; track $index) {
          <td>{{ brand[col.field] }}</td>
        }
      </tr>
    </ng-template>
  </p-table>
</p-card>